import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import InputNumber from 'component/form/InputNumber'
import CustomCompanySelect from 'component/branch/CustomCompanySelect'
import HierarchySelect from 'component/hierarchy/HierarchySelect'
import CustomMissionSelect from 'component/menuMission/CustomMissionSelect'
import { colourStyles } from 'utils/selectStyle'

const FIELDS = [
  'idLocalUsers',
  'dsLdap',
  'nmUser',
  'idBranch',
  'dsBranch',
  'idSection',
  'dsSection',
  'cdMission',
  'dsEmail',
  'dsPassword',
]

const UpdateModal = ({
  closeModal,
  fields,
  handleUpdate,
  setValueToField,
  token,
  translate,
  values,
}) => {
  const beforeHandleSubmit = (event) => {
    event.preventDefault()

    handleUpdate(values)
  }

  const setBranchInfo = (option) => {
    setValueToField('idBranch', option.value)
    setValueToField(
      'dsBranch',
      !option.label || option.label.replace(/\d+ - /, '')
    )
  }

  const setSectionInfo = (option) => {
    setValueToField('idSection', option.value)
    setValueToField('dsSection', option.label)
  }

  return (
    <Modal closeModal={closeModal}>
      <h2>{translate('localUsers.modal.update.title')}</h2>

      <form onSubmit={beforeHandleSubmit}>
        <Row className='margin-top'>
          <Field {...fields.dsLdap}>
            <InputNumber
              {...fields.dsLdap.input}
              integer
              label={translate('localUsers.editForm.field.dsLdap')}
              maxLength={8}
            />
          </Field>
        </Row>

        <Row className='margin-top-small'>
          <Field {...fields.nmUser}>
            <Input
              {...fields.nmUser.input}
              label={translate('localUsers.editForm.field.nmUser')}
              maxLength={100}
            />
          </Field>
        </Row>

        <Row className='margin-top-small'>
          <Field {...fields.idBranch}>
            <CustomCompanySelect
              {...fields.idBranch.input}
              onChange={setBranchInfo}
              token={token}
              translate={translate}
              excludeInactive={true}
            />
          </Field>
        </Row>

        <Row className='margin-top-small'>
          <Field {...fields.idSection}>
            <HierarchySelect
              {...fields.idSection.input}
              isClearable
              onChange={setSectionInfo}
              placeholder={translate('localUsers.editForm.field.idSection')}
              query={{ level: 2 }}
              styles={colourStyles}
              translate={translate}
            />
          </Field>
        </Row>

        <Row className='margin-top-small'>
          <Field {...fields.cdMission}>
            <CustomMissionSelect
              {...fields.cdMission.input}
              onChange={(value) =>
                setValueToField(fields.cdMission.input.name, value)
              }
              token={token}
              translate={translate}
            />
          </Field>
        </Row>

        <Row className='margin-top-small'>
          <Field {...fields.dsEmail}>
            <Input
              {...fields.dsEmail.input}
              label={translate('localUsers.editForm.field.dsEmail')}
              maxLength={100}
              translate={translate}
            />
          </Field>
        </Row>

        <Row className='margin-top-small'>
          <Field {...fields.dsPassword}>
            <Input
              {...fields.dsPassword.input}
              label={translate('localUsers.editForm.field.dsPassword')}
              maxLength={100}
              translate={translate}
            />
          </Field>
        </Row>

        <Row className='align-right margin-top-small'>
          <button
            className='button button-primary margin-right'
            disabled={Object.entries(values).some(
              (keyValue) =>
                keyValue[0] !== 'idLocalUsers' &&
                keyValue[0] !== 'dsPassword' &&
                !keyValue[1]
            )}
          >
            {translate('save_button_label')}
          </button>

          <button
            className='button-hollow button-hollow-primary'
            onClick={closeModal}
          >
            {translate('cancel_button')}
          </button>
        </Row>
      </form>
    </Modal>
  )
}

UpdateModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(UpdateModal)

export { UpdateModal }
